import { render, staticRenderFns } from "./roam.vue?vue&type=template&id=488dbd8a&"
import script from "./roam.vue?vue&type=script&lang=js&"
export * from "./roam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports